import { byteLengthOf } from "./framing";
import type { SnapshotSD3 } from "./snapshot";

// 区画別バイトサイズの計測 (RQ1 図表素材)。パネル表示とデバッグログの両方で使う。

export interface SectionSizes {
  id: number;
  h: number;
  u: number;
  e: number;
  /** エンベロープ ({"s":...,"g":...} とキー名) 込みの完成JSON総バイト */
  total: number;
}

export const sectionSizes = (snap: SnapshotSD3): SectionSizes => ({
  id: byteLengthOf(JSON.stringify(snap.id)),
  h: byteLengthOf(JSON.stringify(snap.h)),
  u: byteLengthOf(JSON.stringify(snap.u)),
  e: byteLengthOf(JSON.stringify(snap.e)),
  total: byteLengthOf(JSON.stringify(snap)),
});
